<template>
  <div class="more_button">
    <div>
        <!-- <a :href="button_href"> -->
        <router-link :to="button_href">  
          {{button_text}}
        </router-link>
        <!-- </a> -->
      </div>
  </div>
</template>

<script>
export default {
  name: 'moreButton',
  props:  ["button_text","button_href"]
}
</script>

<style>
.more_button{
  margin: 50px 0 50px;
}
  .more_button div{
    width: 150px;
    height: 40px;
   
    font-weight: 700;
    text-align: center;
    line-height: 36px;
    
    margin: 0 auto;
  }
  .more_button div a{
    display: inline-block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color:#00a0e9;
     border: 2px solid #00a0e9;
     transition: all .5s;
  }
  .more_button div a:hover{
    color:white;
    background: #00a0e9;
  }
</style>
